webpackJsonp([152659631335596],{

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/yearend-party-2.263adfc5.jpg";

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  line-height: 2;\n  font-size: 1.125rem;\n'], ['\n  line-height: 2;\n  font-size: 1.125rem;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  background-color: #d21618;\n  padding: 0.75rem 1.5rem;\n  color: #fff;\n  text-decoration: none;\n  margin-top: 1rem;\n'], ['\n  display: inline-block;\n  background-color: #d21618;\n  padding: 0.75rem 1.5rem;\n  color: #fff;\n  text-decoration: none;\n  margin-top: 1rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _PagePost = __webpack_require__(12);
	
	var _PagePost2 = _interopRequireDefault(_PagePost);
	
	var _Paragraph = __webpack_require__(16);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _FullWidth = __webpack_require__(8);
	
	var _FullWidth2 = _interopRequireDefault(_FullWidth);
	
	var _Container = __webpack_require__(6);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _PrimaryImage = __webpack_require__(21);
	
	var _PrimaryImage2 = _interopRequireDefault(_PrimaryImage);
	
	var _SuggestedPage = __webpack_require__(17);
	
	var _SuggestedPage2 = _interopRequireDefault(_SuggestedPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// eslint-disable-next-line import/no-extraneous-dependencies
	
	// eslint-disable-next-line import/no-extraneous-dependencies
	
	
	var Li = _styledComponents2.default.li(_templateObject);
	
	var A = _styledComponents2.default.a(_templateObject2);
	
	var PageYearEndParty = function PageYearEndParty() {
	  return _react2.default.createElement(
	    _PagePost2.default,
	    {
	      back: '#yearend-party',
	      title: '2017\u5E74\u6176\u795D\u6D3E\u5C0D\u66A8\u300C123\u65E5\u6539\u8B8A\u300D\u56DE\u9867',
	      introduction: '\u70BA\u7B54\u8B1D\u53F8\u6A5F\u5925\u4F34\u672C\u5E74\u5EA6\u5C0D Uber \u7684\u652F\u6301\uFF0C\u6211\u5011\u5C07\u65BC12\u670810\u65E5\uFF08\u661F\u671F\u65E5\uFF09\u8209\u8FA6\u6176\u795D\u6D3E\u5C0D\u66A8\u300C123\u65E5\u6539\u8B8A\u300D\u56DE\u9867\u3002'
	    },
	    _react2.default.createElement(
	      _FullWidth2.default,
	      null,
	      _react2.default.createElement(
	        _Container2.default,
	        { padding: '3rem 3rem 1rem' },
	        _react2.default.createElement(_PrimaryImage2.default, { src: __webpack_require__(782) }),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          '\u70BA\u7B54\u8B1D\u53F8\u6A5F\u5925\u4F34\u672C\u5E74\u5EA6\u5C0D Uber \u7684\u652F\u6301\u8207\u539A\u611B\uFF0C\u6211\u5011\u5C07\u65BC12\u670810\u65E5\uFF08\u661F\u671F\u65E5\uFF09\u8209\u8FA6\u6176\u795D\u6D3E\u5C0D\u66A8\u300C123\u65E5\u6539\u8B8A\u300D\u56DE\u9867\u3002\u8AA0\u9080\u4F60\u7576\u65E5\u4E0B\u5348\u5E36\u540C\u89AA\u53CB\u4EAB\u7528\u9152\u5E97\u81EA\u52A9\u9910\u53CA\u53C3\u8207\u4E00\u7CFB\u5217\u7BC0\u76EE\u5305\u62EC\u62BD\u734E\u74B0\u7BC0*\u3002'
	        ),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          '\u65E5\u671F\u53CA\u6642\u9593: 12\u670810\u65E5 \uFF08\u661F\u671F\u65E5\uFF093:30 - 5:30 pm',
	          _react2.default.createElement('br', null),
	          '\u5730\u9EDE\uFF1A\u4E5D\u9F8D\u57CE\uFF08\u8A73\u7D30\u5730\u5740\u5C07\u901A\u904E\u78BA\u8A8D\u96FB\u90F5\u901A\u77E5\uFF09'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          '\u6D3B\u52D5\u5167\u5BB9'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            Li,
	            null,
	            '\u81EA\u52A9\u9910'
	          ),
	          _react2.default.createElement(
	            Li,
	            null,
	            '\u8C50\u5BCC\u79AE\u54C1'
	          ),
	          _react2.default.createElement(
	            Li,
	            null,
	            '\u62BD\u734E\u74B0\u7BC0'
	          ),
	          _react2.default.createElement(
	            Li,
	            null,
	            '\u9812\u767C\u5341\u4E00\u6708\u4EFD\u300C\u6BCF\u6708\u4E4B\u661F\u300D\u734E\u9805'
	          )
	        ),
	        _react2.default.createElement(
	          _Paragraph2.default,
	          null,
	          '\u53EF\u651C\u540C\u5169\u4F4D\u89AA\u53CB\u51FA\u5E2D\uFF0C\u6D3B\u52D5\u8CBB\u7528\u5168\u514D\uFF08\u514D\u8CBB\u6CCA\u8ECA\u4F4D\u5148\u5230\u5148\u6CCA\uFF09'
	        ),
	        '*\u6B61\u8FCE\u6240\u6709\u53F8\u6A5F\u5925\u4F34\u5831\u540D\uFF0C\u5341\u4E00\u6708\u300C\u6BCF\u6708\u4E4B\u661F\u300D\u53CA\u5F9E\u672A\u53C3\u52A0 Uber \u6D3B\u52D5\u7684\u512A\u79C0\u53F8\u6A5F\u5925\u4F34\u512A\u5148\u3002',
	        _react2.default.createElement(
	          _Paragraph2.default,
	          { style: { marginBottom: 48 } },
	          _react2.default.createElement(
	            A,
	            {
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              href: 'http://t.uber.com/123buffet'
	            },
	            '\u4E86\u89E3\u66F4\u591A'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        { padding: '3rem' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          '\u5176\u4ED6\u76F8\u95DC\u6D3B\u52D5'
	        ),
	        _react2.default.createElement(
	          _SuggestedPage2.default,
	          {
	            to: '/monthly-star',
	            bg: __webpack_require__(180)
	          },
	          '\u6BCF\u6708\u4E4B\u661F'
	        ),
	        _react2.default.createElement(
	          _SuggestedPage2.default,
	          {
	            to: '/giveaway',
	            bg: __webpack_require__(174)
	          },
	          '\u8056\u8A95\u65B0\u5E74\u661F\u7D1A\u884C\u7A0B\u5927\u8CDE'
	        )
	      )
	    )
	  );
	};
	
	exports.default = PageYearEndParty;
	module.exports = exports['default'];

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PageYearEndParty = __webpack_require__(378);
	
	var _PageYearEndParty2 = _interopRequireDefault(_PageYearEndParty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PageYearEndParty2.default;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-yearend-party-jsx-083e52f7c12fb7265b45.js